var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 361,
    viewBox: "0 0 394 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_19374)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M376.489 200.139C387.691 214.552 394 230.638 394 247.367V191.645C394 174.787 387.691 158.829 376.489 144.416V200.139Z",
    fill: "url(#paint0_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M225.971 78.5274C268.332 82.1307 306.187 93.584 335.158 110.185V165.907C306.187 149.306 268.332 137.853 225.971 134.25V78.5274Z",
    fill: "url(#paint1_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M47.2544 117.52C73.7786 99.5037 109.573 86.3774 150.39 80.5864V136.309C109.573 142.1 73.6498 155.226 47.2544 173.243V117.52Z",
    fill: "url(#paint2_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M0 247.496C0 246.853 0 246.081 0 245.437C0.386275 232.826 4.24902 220.858 11.0732 209.533V153.811C4.24902 165.006 0.386275 177.103 0 189.715C0 190.358 0 191.13 0 191.774V247.496Z",
    fill: "url(#paint3_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M9.39935 282.5C3.34771 271.432 0 259.722 0 247.496V191.774C0 203.999 3.34771 215.839 9.39935 226.777V282.5Z",
    fill: "url(#paint4_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M145.497 302.318C104.938 296.012 69.6584 282.242 43.9067 263.84V319.562C69.5296 337.965 104.938 351.606 145.497 358.04V302.318Z",
    fill: "url(#paint5_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M331.553 275.422C301.809 291.637 263.44 302.447 221.078 305.406V361.129C263.44 358.169 301.809 347.23 331.553 331.144V275.422Z",
    fill: "url(#paint6_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M394 249.427C393.485 266.671 386.532 282.886 374.3 297.299V241.577C386.403 227.035 393.485 210.82 394 193.704V249.427Z",
    fill: "url(#paint7_linear_58_19374)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M186.313 224.332C189.79 222.273 194.168 222.273 197.644 224.332L264.985 263.068C266.015 263.711 266.015 265.255 264.985 265.77L197 305.02C193.91 306.822 190.047 306.822 187.086 305.02L119.102 265.899C118.072 265.255 118.072 263.711 119.102 263.196L186.313 224.332Z",
    fill: "url(#paint8_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M186.313 213.008C189.79 210.949 194.168 210.949 197.644 213.008L264.985 251.743C266.015 252.386 266.015 253.931 264.985 254.445L197 293.696C193.91 295.497 190.047 295.497 187.086 293.696L119.102 254.574C118.072 253.931 118.072 252.386 119.102 251.872L186.313 213.008Z",
    fill: "url(#paint9_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M186.313 201.683C189.79 199.624 194.168 199.624 197.644 201.683L264.985 240.418C266.015 241.062 266.015 242.606 264.985 243.121L197 282.371C193.91 284.173 190.047 284.173 187.086 282.371L119.102 243.249C118.072 242.606 118.072 241.062 119.102 240.547L186.313 201.683Z",
    fill: "url(#paint10_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M186.313 190.358C189.79 188.299 194.168 188.299 197.644 190.358L264.985 229.094C266.015 229.737 266.015 231.281 264.985 231.796L197 271.046C193.91 272.848 190.047 272.848 187.086 271.046L119.102 231.925C118.072 231.281 118.072 229.737 119.102 229.222L186.313 190.358Z",
    fill: "url(#paint11_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M119.102 229.222L186.313 190.358C189.79 188.299 194.168 188.299 197.644 190.358L264.985 229.094C265.5 229.351 265.757 229.994 265.757 230.509V264.483C265.757 264.998 265.5 265.513 264.985 265.899L197 305.149C193.91 306.951 190.047 306.951 187.086 305.149L119.102 266.027C118.587 265.77 118.329 265.127 118.329 264.612V230.638C118.329 229.994 118.587 229.48 119.102 229.222Z",
    fill: "url(#paint12_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M185.154 162.561C189.403 160.116 194.682 160.116 198.803 162.561L280.435 209.533C281.723 210.305 281.723 212.107 280.435 212.879L198.03 260.365C194.296 262.553 189.661 262.553 185.927 260.365L103.393 212.879C102.105 212.107 102.105 210.305 103.393 209.533L185.154 162.561Z",
    fill: "url(#paint13_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M185.154 148.792C189.403 146.347 194.682 146.347 198.803 148.792L280.435 195.763C281.723 196.535 281.723 198.337 280.435 199.109L198.03 246.595C194.296 248.783 189.661 248.783 185.927 246.595L103.393 199.109C102.105 198.337 102.105 196.535 103.393 195.763L185.154 148.792Z",
    fill: "url(#paint14_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M185.154 135.022C189.403 132.577 194.682 132.577 198.803 135.022L280.435 181.993C281.723 182.766 281.723 184.567 280.435 185.339L198.03 232.826C194.296 235.013 189.661 235.013 185.927 232.826L103.393 185.339C102.105 184.567 102.105 182.766 103.393 181.993L185.154 135.022Z",
    fill: "url(#paint15_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M185.154 121.252C189.403 118.807 194.682 118.807 198.803 121.252L280.435 168.224C281.723 168.996 281.723 170.798 280.435 171.57L198.03 219.056C194.296 221.244 189.661 221.244 185.927 219.056L103.393 171.57C102.105 170.798 102.105 168.996 103.393 168.224L185.154 121.252Z",
    fill: "url(#paint16_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.651 168.352L185.283 121.252C189.532 118.807 194.811 118.807 198.932 121.252L280.564 168.224C281.208 168.61 281.466 169.253 281.466 169.897V211.206C281.466 211.849 281.208 212.493 280.564 212.879L198.159 260.365C194.425 262.553 189.79 262.553 186.056 260.365L103.522 212.879C102.878 212.493 102.621 211.849 102.621 211.206V169.897C102.621 169.382 103.007 168.738 103.651 168.352Z",
    fill: "url(#paint17_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M185.154 121.252C189.403 118.807 194.682 118.807 198.803 121.252L280.435 168.224C281.723 168.996 281.723 170.798 280.435 171.57L198.03 219.056C194.296 221.244 189.661 221.244 185.927 219.056L103.393 171.57C102.105 170.798 102.105 168.996 103.393 168.224L185.154 121.252Z",
    fill: "url(#paint18_linear_58_19374)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.651 169.768L186.185 217.254C189.919 219.442 194.554 219.442 198.288 217.254L280.693 169.768C280.951 169.639 281.208 169.382 281.466 168.996C281.981 169.897 281.723 171.055 280.693 171.57L198.288 219.056C194.554 221.244 189.919 221.244 186.185 219.056L103.651 171.57C102.621 171.055 102.492 169.768 102.878 168.996C103.007 169.382 103.264 169.639 103.651 169.768Z",
    fill: "url(#paint19_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.107 196.149C216.925 196.149 237.044 184.511 237.044 170.154C237.044 155.797 216.925 144.159 192.107 144.159C167.29 144.159 147.171 155.797 147.171 170.154C147.171 184.511 167.29 196.149 192.107 196.149Z",
    fill: "#180D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.097 131.161C130.303 137.081 115.11 144.931 110.346 140.298C105.581 135.665 113.178 120.351 118.972 114.432C124.766 108.512 133.264 107.482 138.029 112.115C142.793 116.748 141.891 125.242 136.097 131.161Z",
    fill: "url(#paint20_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.097 131.161C130.303 137.081 115.11 144.931 110.346 140.298C105.581 135.665 113.178 120.351 118.972 114.432C124.766 108.512 133.264 107.482 138.029 112.115C142.793 116.748 141.891 125.242 136.097 131.161Z",
    fill: "url(#paint21_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87 115.204C136.483 115.204 136.097 115.075 135.839 114.946C134.423 114.303 133.779 112.759 134.294 111.343L142.921 90.8816C143.565 89.466 145.11 88.8225 146.526 89.3373C147.943 89.9807 148.586 91.525 148.071 92.9406L139.445 113.402C138.93 114.56 137.9 115.204 136.87 115.204Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.978 107.653L240.846 109.729L258.672 153.749L263.805 151.672L245.978 107.653Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.033 98.6029C160.562 98.6029 168.286 90.8824 168.286 81.3586C168.286 71.8348 160.562 64.1143 151.033 64.1143C141.504 64.1143 133.779 71.8348 133.779 81.3586C133.779 90.8824 141.504 98.6029 151.033 98.6029Z",
    fill: "url(#paint22_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.432 66.8167C168.415 71.9643 170.862 82.6455 165.711 90.6242C160.561 98.6029 149.874 101.048 141.891 95.9005C133.908 90.7529 131.462 80.0717 136.612 72.093C141.633 64.1143 152.32 61.6691 160.432 66.8167Z",
    fill: "url(#paint23_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.172 112.759C237.172 146.218 217.214 173.371 192.622 173.371C168.029 173.371 148.071 146.218 148.071 112.759C148.071 79.2996 168.029 69.2618 192.622 69.2618C217.214 69.2618 237.172 79.1709 237.172 112.759Z",
    fill: "url(#paint24_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.172 112.759C237.172 146.218 217.214 173.371 192.622 173.371C168.029 173.371 148.071 146.218 148.071 112.759C148.071 79.2996 168.029 69.2618 192.622 69.2618C217.214 69.2618 237.172 79.1709 237.172 112.759Z",
    fill: "url(#paint25_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.124 99.6324C202.279 106.453 182.965 106.453 171.119 99.6324C159.273 92.8119 159.273 81.616 171.119 74.7954C182.965 67.9749 202.279 67.9749 214.124 74.7954C225.97 81.616 225.97 92.6832 214.124 99.6324Z",
    fill: "#393091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.119 79.4282C182.965 72.6077 202.279 72.6077 214.124 79.4282C219.017 82.2594 221.85 85.8627 222.751 89.466C223.91 84.1897 221.077 78.7848 214.124 74.6668C202.279 67.8462 182.965 67.8462 171.119 74.6668C164.166 78.6561 161.205 84.1897 162.492 89.466C163.265 85.8627 166.226 82.2594 171.119 79.4282Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.471 45.4543L163.008 35.9313C166.227 32.5854 168.802 28.0813 170.089 23.5772L175.626 13.9255L167.643 9.29267C167.385 9.16398 167.128 8.9066 166.87 8.77791C164.553 7.7484 161.591 8.00578 158.244 9.93611C151.162 14.0542 145.368 23.9632 145.368 32.1993C145.368 36.3174 146.784 39.1485 149.102 40.5641L157.471 45.4543Z",
    fill: "url(#paint26_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.567 34.9722C180.58 26.2938 180.601 16.9251 175.613 14.0466C170.624 11.1681 162.517 15.87 157.503 24.5484C152.49 33.2268 152.469 42.5956 157.458 45.474C162.446 48.3525 170.554 43.6507 175.567 34.9722Z",
    fill: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.424 90.7529C219.527 90.7529 239.876 70.4144 239.876 45.3256C239.876 20.2369 219.527 -0.101624 194.424 -0.101624C169.322 -0.101624 148.973 20.2369 148.973 45.3256C148.973 70.4144 169.322 90.7529 194.424 90.7529Z",
    fill: "url(#paint27_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.424 90.7529C219.527 90.7529 239.876 70.4144 239.876 45.3256C239.876 20.2369 219.527 -0.101624 194.424 -0.101624C169.322 -0.101624 148.973 20.2369 148.973 45.3256C148.973 70.4144 169.322 90.7529 194.424 90.7529Z",
    fill: "url(#paint28_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79 75.9536L225.326 66.4306C228.545 63.0847 231.121 58.5806 232.408 54.0765L237.945 44.4248L229.962 39.792C229.704 39.6633 229.447 39.4059 229.189 39.2772C226.871 38.2477 223.91 38.5051 220.562 40.4354C213.481 44.5535 207.687 54.4626 207.687 62.6987C207.687 66.8167 209.103 69.6479 211.421 71.0634L219.79 75.9536Z",
    fill: "url(#paint29_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79 75.9536L225.326 66.4306C228.545 63.0847 231.121 58.5806 232.408 54.0765L237.945 44.4248L229.962 39.792C229.704 39.6633 229.447 39.4059 229.189 39.2772C226.871 38.2477 223.91 38.5051 220.562 40.4354C213.481 44.5535 207.687 54.4626 207.687 62.6987C207.687 66.8167 209.103 69.6479 211.421 71.0634L219.79 75.9536Z",
    fill: "url(#paint30_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.85 65.5256C242.864 56.8471 242.884 47.4784 237.896 44.6C232.908 41.7215 224.8 46.4233 219.786 55.1018C214.773 63.7802 214.753 73.1489 219.741 76.0274C224.729 78.9058 232.837 74.204 237.85 65.5256Z",
    fill: "#BCBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.571 67.7176C216.571 59.4814 222.365 49.5724 229.446 45.4543C231.893 44.0388 234.21 43.524 236.142 43.7814C234.082 43.2666 231.507 43.7814 228.803 45.3256C221.721 49.4437 215.927 59.3528 215.927 67.5889C215.927 72.9938 218.373 76.211 222.107 76.7258C218.759 76.0823 216.571 72.8651 216.571 67.7176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.073 54.9773C238.073 60.7683 233.953 67.9749 228.931 70.8061C223.91 73.7659 219.79 71.3208 219.79 65.5298C219.79 59.7388 223.91 52.5322 228.931 49.7011C233.953 46.7412 238.073 49.0576 238.073 54.9773Z",
    fill: "#393091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.082 48.5429C234.983 49.7011 235.627 51.374 235.627 53.4331C235.627 59.2241 231.507 66.4307 226.485 69.2618C224.554 70.42 222.751 70.6774 221.206 70.42C222.88 72.3504 225.713 72.6078 228.932 70.8061C233.953 67.8463 238.073 60.7683 238.073 54.9773C238.073 51.374 236.528 49.0576 234.082 48.5429Z",
    fill: "#453C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.261 66.8167C179.103 75.6962 172.407 78.5274 165.197 73.1225C157.986 67.5888 153.222 56.0068 154.381 46.9986C155.54 38.119 162.235 35.2879 169.446 40.6928C176.527 46.2264 181.42 57.8085 180.261 66.8167Z",
    fill: "#393091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.338 59.0954C173.952 62.3126 171.505 63.3421 168.801 61.4118C166.226 59.4814 164.424 55.2347 164.81 51.8888C165.196 48.6715 167.643 47.642 170.347 49.5724C172.922 51.5027 174.724 55.7495 174.338 59.0954Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.544 71.7069C161.334 66.1733 156.57 54.5912 157.728 45.583C158.244 41.9797 159.66 39.2772 161.591 37.8617C157.857 38.2477 155.025 41.3363 154.252 46.8699C153.093 55.7494 157.986 67.4601 165.068 72.9938C169.317 76.211 173.437 76.5971 176.27 74.4094C173.952 74.7954 171.377 73.8946 168.544 71.7069Z",
    fill: "#453C9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.711 72.7364C158.501 67.2028 153.737 55.6207 154.896 46.6125C155.411 42.4945 157.213 39.6633 159.531 38.3764C156.827 39.5346 154.767 42.4945 154.252 46.8699C153.093 55.7494 157.986 67.4601 165.068 72.9938C168.93 75.9536 172.664 76.4684 175.497 74.9241C172.793 76.211 169.317 75.5676 165.711 72.7364Z",
    fill: "#42E8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.353 126.014C252.882 126.014 260.606 118.293 260.606 108.769C260.606 99.2456 252.882 91.525 243.353 91.525C233.824 91.525 226.099 99.2456 226.099 108.769C226.099 118.293 233.824 126.014 243.353 126.014Z",
    fill: "url(#paint31_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.353 126.014C252.882 126.014 260.606 118.293 260.606 108.769C260.606 99.2456 252.882 91.525 243.353 91.525C233.824 91.525 226.099 99.2456 226.099 108.769C226.099 118.293 233.824 126.014 243.353 126.014Z",
    fill: "url(#paint32_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.907 165.907C269.877 174.143 262.666 189.586 256.1 188.814C249.533 188.042 246.185 171.184 247.087 163.076C248.117 154.84 254.168 148.92 260.735 149.693C267.302 150.465 271.937 157.671 270.907 165.907Z",
    fill: "url(#paint33_radial_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.907 165.907C269.877 174.143 262.666 189.586 256.1 188.814C249.533 188.042 246.185 171.184 247.087 163.076C248.117 154.84 254.168 148.92 260.735 149.693C267.302 150.465 271.937 157.671 270.907 165.907Z",
    fill: "url(#paint34_linear_58_19374)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.439 -74.3552V169.511C103.181 170.283 103.439 171.184 104.34 171.698L186.874 219.185C190.608 221.372 195.243 221.372 198.977 219.185L281.383 171.698C282.026 171.312 282.284 170.669 282.284 170.025V-74.3552H103.439Z",
    fill: "url(#paint35_linear_58_19374)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_19374",
    x1: 376.476,
    y1: 195.969,
    x2: 394.006,
    y2: 195.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_19374",
    x1: 226.034,
    y1: 122.239,
    x2: 335.226,
    y2: 122.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_19374",
    x1: 47.1958,
    y1: 126.843,
    x2: 150.359,
    y2: 126.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_19374",
    x1: 0,
    y1: 200.694,
    x2: 11.0525,
    y2: 200.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_19374",
    x1: 0,
    y1: 237.187,
    x2: 9.43797,
    y2: 237.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_19374",
    x1: 43.9382,
    y1: 310.889,
    x2: 145.477,
    y2: 310.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_19374",
    x1: 221.072,
    y1: 318.218,
    x2: 331.549,
    y2: 318.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_58_19374",
    x1: 374.32,
    y1: 245.582,
    x2: 393.975,
    y2: 245.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_58_19374",
    x1: 265.846,
    y1: 264.661,
    x2: 118.306,
    y2: 264.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_58_19374",
    x1: 265.846,
    y1: 253.317,
    x2: 118.306,
    y2: 253.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_58_19374",
    x1: 265.846,
    y1: 241.973,
    x2: 118.306,
    y2: 241.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_58_19374",
    x1: 265.846,
    y1: 230.63,
    x2: 118.306,
    y2: 230.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_58_19374",
    x1: 265.846,
    y1: 247.645,
    x2: 118.306,
    y2: 247.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_58_19374",
    x1: 281.526,
    y1: 211.376,
    x2: 102.625,
    y2: 211.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_58_19374",
    x1: 281.526,
    y1: 197.621,
    x2: 102.625,
    y2: 197.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_58_19374",
    x1: 281.526,
    y1: 183.866,
    x2: 102.625,
    y2: 183.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_58_19374",
    x1: 281.526,
    y1: 170.111,
    x2: 102.625,
    y2: 170.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_58_19374",
    x1: 281.526,
    y1: 190.743,
    x2: 102.625,
    y2: 190.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_58_19374",
    x1: 281.526,
    y1: 170.111,
    x2: 102.625,
    y2: 170.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_58_19374",
    x1: 281.525,
    y1: 194.902,
    x2: 102.626,
    y2: 194.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0725775,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E8E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.586 105.336) rotate(44.3886) scale(30.6237 50.4458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_58_19374",
    x1: 140.452,
    y1: 120.831,
    x2: 113.19,
    y2: 122.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.698 26.2259) rotate(11.1917) scale(99.6931 99.6436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_58_19374",
    x1: 141.814,
    y1: 95.933,
    x2: 160.357,
    y2: 66.8061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.939 103.627) scale(76.6329 104.262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_58_19374",
    x1: 192.629,
    y1: 173.389,
    x2: 192.629,
    y2: 69.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.731 -25.2862) scale(53.9655 53.9366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.78 38.5361) scale(76.8679 76.8266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_58_19374",
    x1: 188.067,
    y1: 90.288,
    x2: 200.714,
    y2: 0.250531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.165 37.7188) scale(36.505 36.4854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_58_19374",
    x1: 214.815,
    y1: 74.1794,
    x2: 227.63,
    y2: 38.9498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(253.599 97.4398) rotate(11.1917) scale(36.0312 36.0134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_58_19374",
    x1: 229.394,
    y1: 118.852,
    x2: 257.328,
    y2: 98.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_58_19374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.401 152.281) rotate(6.79923) scale(30.6312 50.4319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_58_19374",
    x1: 246.588,
    y1: 167.824,
    x2: 270.343,
    y2: 170.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00467455,
    stopColor: "#42E6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1358,
    stopColor: "#40B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2707,
    stopColor: "#3E8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#3C6BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#3B519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6893,
    stopColor: "#3A3F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#393493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_58_19374",
    x1: 192.768,
    y1: 220.788,
    x2: 192.768,
    y2: -74.3552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EE1",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    stopColor: "#009EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#0076A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    stopColor: "#054764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6004,
    stopColor: "#030239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7478,
    stopColor: "#030239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8845,
    stopColor: "#030239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030239"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_19374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 361,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.f4e910a20493cb462a30c8dda7961116.svg";
export { ForwardRef as ReactComponent };